function clamp(value) {
    return Math.max(0, Math.min(value, 100));
}
var UIProgressBarComponent = /** @class */ (function () {
    function UIProgressBarComponent() {
    }
    Object.defineProperty(UIProgressBarComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            this._value = clamp(value);
        },
        enumerable: true,
        configurable: true
    });
    return UIProgressBarComponent;
}());
export { UIProgressBarComponent };
